import styled from 'styled-components'

export const GridWrapper = styled.div<{ smallMobileTiles: boolean }>`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  column-gap: 20px;
  row-gap: 40px;
  background: white;
  position: relative;
  z-index: 1;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    gap: ${({ smallMobileTiles }) => (smallMobileTiles ? '0' : '40')}px;
  }
`

export const ArrowButton = styled.button`
  border-radius: 64px;
  width: 50px;
  height: 50px;
  flex-shrink: 0;
  background-color: white;
  border: 2px solid #fac532;
  cursor: pointer;
`

export const ViewAllLink = styled.div`
  color: var(--brand-secondary);
  cursor: pointer;
  text-align: center;

  &:hover {
    opacity: 0.8;
  }

  @media (max-width: 500px) {
    > div {
      text-decoration: underline;
      font-weight: var(--font-medium);
      font-size: 14px;
      white-space: nowrap;
      position: relative;
      top: -3px;

      > div {
        width: 60px;
        display: none;
      }
    }
  }
`

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;

  @media (max-width: 600px) {
    & > button {
      width: 100%;
    }
  }
`

export const ContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 10px;
  position: relative;

  & > h1 {
    font-size: 48px;
  }

  @media (max-width: 600px) {
    justify-content: space-between;
    & > h1 {
      width: 200px;
      font-size: 24px;
    }
  }
`
